import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { selectedCreneauxSlice } from './selectedCreneauxSlice.js';
import { elevesSlice } from './elevesSlice.js';
import { formulesSlice } from './formulesSlice.js';
import { formulesElevesSlice } from './formulesElevesSlice.js';
import { commentaireSlice } from './commentaireSlice.js';
import { clientSlice } from './clientSlice.js';
import { resaSlice } from './resaSlice.js';
import { langSlice } from './langSlice.js';
import { stepLocationSlice } from './stepLocationSlice.js';
import { locationSlice } from './locationSlice.js';
import { panierSlice } from './panierSlice.js';


//list of global states
let state = {
    selectedCreneaux: [],
    eleves: [],
    formules: [],
    formulesEleves: [],
    commentaire: "",
    client: {},
    resa: {},
    lang: "fr",
    stepLocation: 1,
    location: {},
    panier: []
};

export const store = configureStore(
    {
        preloadedState: state,
        reducer: combineReducers({
            selectedCreneaux: selectedCreneauxSlice.reducer,
            eleves: elevesSlice.reducer,
            formules: formulesSlice.reducer,
            formulesEleves: formulesElevesSlice.reducer,
            commentaire: commentaireSlice.reducer,
            client: clientSlice.reducer,
            resa: resaSlice.reducer,
            lang: langSlice.reducer,
            stepLocation: stepLocationSlice.reducer,
            location: locationSlice.reducer,
            panier: panierSlice.reducer
        }),
    }
)
